<template>
  <section class="qu">

    <div class="qu-body section-block unit">
      <div class="qu-head">
          <p class="qu-head__num"><span>Q{{ questionNum }}</span></p>
          <p class="qu-head__calc">あと<span>{{ calculated }}</span>問</p>
      </div>

      <div class="qu-select">
        <p class="qu-select__text"><span>{{ questionText }}</span></p>
        <ul class="qu-select__list">
          <li class="qu-select__item">
            <button class="qu-select__btn qu-select__btn--yes" @click="onClickYesBtn"></button>
          </li>
          <li class="qu-select__item">
            <button class="qu-select__btn qu-select__btn--no" @click="onClickNoBtn"></button>
          </li>
        </ul>
      </div>
    </div>

    <div class="qu-note u-small-text section-block unit">
      <p class="qu-note__text">前の問題に戻ることは出来ません。ご使用機種の戻るボタンを押した場合は、診断TOPへ戻ります。</p>
      <button class="qu-note__btn restart-btn" @click="onClick">診断TOPに戻る</button>
    </div>

  </section>
</template>


<script>
export default {
  name: 'Question',

  props: {
    // 問題文
    questionNum: Number,
    questionText: String,
    pointYes: Number,
    pointNo: Number
  },

  computed: {
    calculated: function() {
      return 18 - this.questionNum+1
    }
  },

  methods: {
    onClickYesBtn: function () {
      // YESボタンをクリックし、YES用の値とイベントを親コンポーネントへ返す
      this.$emit('click-yes-btn', this.pointYes)
    },
    onClickNoBtn: function () {
      // NOボタンをクリックし、NO用の値とイベントを親コンポーネントへ返す
      this.$emit('click-no-btn', this.pointNo)
    },

    onClick: function() {
      this.$emit('click-restart')
    }
  }
}
</script>


<style scoped>
</style>